import React from "react";
import "../../../assets/css/AdBanner.css";
import Addss from "../../../assets/images/internet-ad.jpeg"

const Adds = () => {
  return (
    <div className="ad-banner">
      <div className="ad-label">Adds</div>
      <img
        src={Addss}
        alt="Ad Banner"
        className="ad-image"
      />
            <div className="ad-label">Adds</div>
      <img
        src={Addss}
        alt="Ad Banner"
        className="ad-image"
      />
        <div className="ad-label">Adds</div>
      <img
        src={Addss}
        alt="Ad Banner"
        className="ad-image"
      />
    </div>
  );
};

export default Adds;
